import type { CompleteFn } from "@nl2sparql/core";

/**
 * A browser-side Anthropic caller for the optional LLM fallback (BYOK).
 * Note: the key lives in the browser — fine for a personal tool with your own
 * key, but it is exposed to this page. A server-held key (apps/server) is the
 * production path.
 */
export function makeAnthropicComplete(
  apiKey: string,
  model = "claude-haiku-4-5-20251001",
): CompleteFn {
  return async (prompt, signal) => {
    const res = await fetch("https://api.anthropic.com/v1/messages", {
      method: "POST",
      headers: {
        "content-type": "application/json",
        "x-api-key": apiKey,
        "anthropic-version": "2023-06-01",
        "anthropic-dangerous-direct-browser-access": "true",
      },
      body: JSON.stringify({
        model,
        max_tokens: 400,
        messages: [{ role: "user", content: prompt }],
      }),
      ...(signal ? { signal } : {}),
    });
    if (!res.ok) {
      throw new Error(`Anthropic API error ${res.status}: ${(await res.text()).slice(0, 200)}`);
    }
    const data = (await res.json()) as { content?: Array<{ text?: string }> };
    return data.content?.[0]?.text ?? "";
  };
}
